// Inbox: mail to the site's own domain (package flag `mailbox`).
export const mailboxEn = {
  'mailbox.subtitle': 'Email sent to your domain. It is kept here only, never forwarded.',
  'mailbox.unreadCount': '{count} unread',
  'mailbox.filter.unread': 'Unread',
  'mailbox.filter.allAddresses': 'All addresses',
  'mailbox.searchPlaceholder': 'Search subject or sender…',
  'mailbox.empty.title': 'No email yet',
  'mailbox.empty.body': 'Messages sent to your domain appear here.',
  'mailbox.empty.filtered': 'No messages match these filters.',
  'mailbox.col.from': 'From',
  'mailbox.col.subject': 'Subject',
  'mailbox.col.to': 'To',
  'mailbox.col.received': 'Received',
  'mailbox.col.actions': 'Actions',
  'mailbox.open': 'Open',
  'mailbox.noSubject': '(no subject)',
  'mailbox.unread': 'Unread',
  'mailbox.spam': 'Suspicious',
  'mailbox.prev': '← Previous',
  'mailbox.next': 'Next →',
  'mailbox.pageOf': 'Page {page} of {total}',

  'mailbox.detail.from': 'From',
  'mailbox.detail.to': 'To',
  'mailbox.detail.cc': 'Cc',
  'mailbox.detail.replyTo': 'Reply-To',
  'mailbox.detail.deliveredTo': 'Delivered to',
  'mailbox.detail.sent': 'Sent',
  'mailbox.detail.received': 'Received',
  'mailbox.detail.size': 'Size',
  'mailbox.detail.viewText': 'Plain text',
  'mailbox.detail.viewHtml': 'HTML',
  'mailbox.detail.noText': 'This message has no plain-text version; the text below is taken from its HTML.',
  'mailbox.detail.empty': 'This message has no text.',
  'mailbox.detail.imagesBlocked': 'Remote images are blocked to protect your privacy ({count}).',
  'mailbox.detail.showImages': 'Show images',
  'mailbox.detail.htmlNote': 'Shown in a protected frame: scripts and links are disabled.',
  'mailbox.detail.truncated': 'This message was very long; only the first 500 KB is shown. Download the original to read all of it.',
  'mailbox.detail.spam': 'This message failed the sender checks (SPF/DMARC) or was marked as spam. Be careful with links and attachments.',
  'mailbox.detail.problem': 'Part of this message could not be read or stored ({problem}). Download the original if you need all of it.',
  'mailbox.detail.attachments': 'Attachments',
  'mailbox.detail.download': 'Download',
  'mailbox.detail.skipped.too_large': 'not kept: larger than 8 MB',
  'mailbox.detail.skipped.too_many': 'not kept: only 10 attachments per message are kept',
  'mailbox.detail.skipped.store_failed': 'not kept: could not be saved',
  'mailbox.detail.skippedMore': '{count} more attachment(s) were not kept.',
  'mailbox.detail.downloadRaw': 'Download original (.eml)',
  'mailbox.detail.markUnread': 'Mark as unread',
  'mailbox.detail.markedUnread': 'Marked as unread',
  'mailbox.detail.deleteTitle': 'Delete this email?',
  'mailbox.detail.deleteBody': 'The message and its attachments are deleted for good.',
  'mailbox.detail.deleted': 'Email deleted',
  'mailbox.filter.sent': 'Sent',
  'mailbox.sent': 'Sent',
  'mailbox.failed': 'Not sent',
  'mailbox.toPrefix': 'To: {to}',
  'mailbox.detail.status': 'Status',
  'mailbox.detail.sendError': 'Sending failed: {error}',
  'mailbox.compose.button': 'New email',
  'mailbox.compose.title': 'New email',
  'mailbox.compose.from': 'From',
  'mailbox.compose.fromHint': 'One of the Inbox addresses you may use. Replies to this email come back to it.',
  'mailbox.compose.toHint': 'One email address.',
  'mailbox.compose.toEmpty': 'Enter the address to send to',
  'mailbox.compose.toInvalid': 'Enter one email address, like name@example.com',
  'mailbox.compose.subjectEmpty': 'Write a subject',
  'mailbox.compose.bodyHint': 'Plain text. Each person can send up to {max} new emails a day.',
  'mailbox.compose.sent': 'Email sent. It is in the Inbox under Sent.',
  'mailbox.compose.capReached': 'You can send up to {max} new emails a day. Try again later.',
  'mailbox.compose.noAddress': 'You have no Inbox address to send from. An admin can add one under Inbox → Addresses.',
  'mailbox.thread.title': 'Conversation',
  'mailbox.thread.received': 'Received',
  'mailbox.thread.fromPrefix': 'From: {from}',
  'mailbox.reply.button': 'Reply',
  'mailbox.reply.title': 'Reply',
  'mailbox.reply.to': 'To',
  'mailbox.reply.cc': 'Cc',
  'mailbox.reply.ccHint': 'Optional. Separate addresses with commas (up to {max}).',
  'mailbox.reply.ccInvalid': 'Check the address: {address}',
  'mailbox.reply.ccTooMany': 'Up to {max} Cc addresses.',
  'mailbox.reply.subject': 'Subject',
  'mailbox.reply.body': 'Message',
  'mailbox.reply.bodyHint': 'Sent as plain text. The quoted original below can be edited or removed.',
  'mailbox.reply.bodyEmpty': 'Write a reply first.',
  'mailbox.reply.bodyTooLong': 'The message is too long (at most {max} characters).',
  'mailbox.reply.quoteHeader': 'On {date}, {from} wrote:',
  'mailbox.reply.send': 'Send',
  'mailbox.reply.sending': 'Sending…',
  'mailbox.reply.cancel': 'Cancel',
  'mailbox.reply.sent': 'Reply sent',
  'mailbox.reply.failed': 'The email could not be sent. Make sure Email Sending is active for this domain in Cloudflare. Your reply is saved in the thread.',
  'mailbox.reply.capReached': 'The daily limit of {max} replies has been reached. Try again later.',
  'mailbox.reply.thread': 'Replies',
  'mailbox.reply.noAddress': 'This message has no address to reply to.',
  'mailbox.yourAddresses': 'You see the mail of: {addresses}',
  'mailbox.empty.noAddress': 'No address is given to you yet. Ask an administrator to give you one under Inbox addresses.',
  'mailbox.catchAll': 'Catch-all',
  'mailbox.catchAll.hint': 'Mail to an address that is not in the address list. Only administrators see it.',
  'mailbox.addresses.manage': 'Addresses',
  'mailbox.addresses.title': 'Inbox addresses',
  'mailbox.addresses.subtitle': 'The addresses of your domain and who may use each one. People see, read, answer and delete only the mail of their addresses.',
  'mailbox.addresses.catchAllNote': 'Administrators see every address. Mail to an address that is not in this list is kept in the catch-all, which only administrators see. Removing an address keeps its mail; it moves to the catch-all.',
  'mailbox.addresses.adminOnly': 'Only administrators can manage inbox addresses.',
  'mailbox.addresses.noDomain': 'This site has no mail domain yet, so no address can be added.',
  'mailbox.addresses.new': 'Add address',
  'mailbox.addresses.edit': 'Edit',
  'mailbox.addresses.col.address': 'Address',
  'mailbox.addresses.col.people': 'Who can use it',
  'mailbox.addresses.adminsOnly': 'Administrators only',
  'mailbox.addresses.empty.title': 'No addresses yet',
  'mailbox.addresses.empty.body': 'Add an address such as sales@ to give people their own inbox. Until then all mail is in the catch-all.',
  'mailbox.addresses.deleteTitle': 'Remove {address}?',
  'mailbox.addresses.deleteBody': 'Nobody but administrators will see its mail any more. The mail itself is kept, in the catch-all.',
  'mailbox.addresses.deleted': 'Address removed',
  'mailbox.addresses.saved': 'Address saved',
  'mailbox.addresses.form.local': 'Address',
  'mailbox.addresses.form.domain': 'Domain',
  'mailbox.addresses.form.label': 'Label',
  'mailbox.addresses.form.labelHint': 'Optional, e.g. Sales team.',
  'mailbox.addresses.form.people': 'Who can use this address',
  'mailbox.addresses.form.peopleHint': 'They see, read, answer, mark and delete its mail. Replies go out from this address.',
  'mailbox.addresses.form.noPeople': 'There is nobody to give it to yet: add people under Users first.',
  'mailbox.addresses.form.noInboxAccess': 'Their role does not include the Inbox, so they will not see it until it does.',
  'mailbox.addresses.form.save': 'Save',
} as const

export const mailboxId: Record<keyof typeof mailboxEn, string> = {
  'mailbox.subtitle': 'Email yang dikirim ke domain Anda. Hanya disimpan di sini, tidak pernah diteruskan.',
  'mailbox.unreadCount': '{count} belum dibaca',
  'mailbox.filter.unread': 'Belum dibaca',
  'mailbox.filter.allAddresses': 'Semua alamat',
  'mailbox.searchPlaceholder': 'Cari subjek atau pengirim…',
  'mailbox.empty.title': 'Belum ada email',
  'mailbox.empty.body': 'Pesan yang dikirim ke domain Anda akan muncul di sini.',
  'mailbox.empty.filtered': 'Tidak ada pesan yang cocok dengan filter ini.',
  'mailbox.col.from': 'Dari',
  'mailbox.col.subject': 'Subjek',
  'mailbox.col.to': 'Kepada',
  'mailbox.col.received': 'Diterima',
  'mailbox.col.actions': 'Aksi',
  'mailbox.open': 'Buka',
  'mailbox.noSubject': '(tanpa subjek)',
  'mailbox.unread': 'Belum dibaca',
  'mailbox.spam': 'Mencurigakan',
  'mailbox.prev': '← Sebelumnya',
  'mailbox.next': 'Berikutnya →',
  'mailbox.pageOf': 'Halaman {page} dari {total}',

  'mailbox.detail.from': 'Dari',
  'mailbox.detail.to': 'Kepada',
  'mailbox.detail.cc': 'Cc',
  'mailbox.detail.replyTo': 'Balas ke',
  'mailbox.detail.deliveredTo': 'Dikirim ke',
  'mailbox.detail.sent': 'Dikirim',
  'mailbox.detail.received': 'Diterima',
  'mailbox.detail.size': 'Ukuran',
  'mailbox.detail.viewText': 'Teks biasa',
  'mailbox.detail.viewHtml': 'HTML',
  'mailbox.detail.noText': 'Pesan ini tidak memiliki versi teks biasa; teks di bawah diambil dari HTML-nya.',
  'mailbox.detail.empty': 'Pesan ini tidak berisi teks.',
  'mailbox.detail.imagesBlocked': 'Gambar jarak jauh diblokir untuk melindungi privasi Anda ({count}).',
  'mailbox.detail.showImages': 'Tampilkan gambar',
  'mailbox.detail.htmlNote': 'Ditampilkan dalam bingkai terlindungi: skrip dan tautan dinonaktifkan.',
  'mailbox.detail.truncated': 'Pesan ini sangat panjang; hanya 500 KB pertama yang ditampilkan. Unduh pesan asli untuk membaca seluruhnya.',
  'mailbox.detail.spam': 'Pesan ini gagal dalam pemeriksaan pengirim (SPF/DMARC) atau ditandai sebagai spam. Berhati-hatilah dengan tautan dan lampiran.',
  'mailbox.detail.problem': 'Sebagian pesan ini tidak dapat dibaca atau disimpan ({problem}). Unduh pesan asli jika Anda memerlukan seluruhnya.',
  'mailbox.detail.attachments': 'Lampiran',
  'mailbox.detail.download': 'Unduh',
  'mailbox.detail.skipped.too_large': 'tidak disimpan: lebih dari 8 MB',
  'mailbox.detail.skipped.too_many': 'tidak disimpan: hanya 10 lampiran per pesan yang disimpan',
  'mailbox.detail.skipped.store_failed': 'tidak disimpan: gagal menyimpan',
  'mailbox.detail.skippedMore': '{count} lampiran lainnya tidak disimpan.',
  'mailbox.detail.downloadRaw': 'Unduh pesan asli (.eml)',
  'mailbox.detail.markUnread': 'Tandai belum dibaca',
  'mailbox.detail.markedUnread': 'Ditandai belum dibaca',
  'mailbox.detail.deleteTitle': 'Hapus email ini?',
  'mailbox.detail.deleteBody': 'Pesan dan lampirannya akan dihapus permanen.',
  'mailbox.detail.deleted': 'Email dihapus',
  'mailbox.filter.sent': 'Terkirim',
  'mailbox.sent': 'Terkirim',
  'mailbox.failed': 'Gagal terkirim',
  'mailbox.toPrefix': 'Kepada: {to}',
  'mailbox.detail.status': 'Status',
  'mailbox.detail.sendError': 'Pengiriman gagal: {error}',
  'mailbox.compose.button': 'Email baru',
  'mailbox.compose.title': 'Email baru',
  'mailbox.compose.from': 'Dari',
  'mailbox.compose.fromHint': 'Salah satu alamat Kotak Masuk yang boleh Anda pakai. Balasan untuk email ini masuk ke alamat itu.',
  'mailbox.compose.toHint': 'Satu alamat email.',
  'mailbox.compose.toEmpty': 'Isi alamat tujuan',
  'mailbox.compose.toInvalid': 'Isi satu alamat email, misalnya nama@contoh.com',
  'mailbox.compose.subjectEmpty': 'Isi subjeknya',
  'mailbox.compose.bodyHint': 'Teks biasa. Tiap orang bisa mengirim sampai {max} email baru per hari.',
  'mailbox.compose.sent': 'Email terkirim. Ada di Kotak Masuk, bagian Terkirim.',
  'mailbox.compose.capReached': 'Anda bisa mengirim sampai {max} email baru per hari. Coba lagi nanti.',
  'mailbox.compose.noAddress': 'Anda belum punya alamat Kotak Masuk untuk mengirim. Admin bisa menambahkannya di Kotak Masuk → Alamat.',
  'mailbox.thread.title': 'Percakapan',
  'mailbox.thread.received': 'Diterima',
  'mailbox.thread.fromPrefix': 'Dari: {from}',
  'mailbox.reply.button': 'Balas',
  'mailbox.reply.title': 'Balas',
  'mailbox.reply.to': 'Kepada',
  'mailbox.reply.cc': 'Cc',
  'mailbox.reply.ccHint': 'Opsional. Pisahkan alamat dengan koma (maksimal {max}).',
  'mailbox.reply.ccInvalid': 'Periksa alamat ini: {address}',
  'mailbox.reply.ccTooMany': 'Maksimal {max} alamat Cc.',
  'mailbox.reply.subject': 'Subjek',
  'mailbox.reply.body': 'Pesan',
  'mailbox.reply.bodyHint': 'Dikirim sebagai teks biasa. Kutipan pesan asli di bawah boleh diubah atau dihapus.',
  'mailbox.reply.bodyEmpty': 'Tulis balasan terlebih dahulu.',
  'mailbox.reply.bodyTooLong': 'Pesan terlalu panjang (maksimal {max} karakter).',
  'mailbox.reply.quoteHeader': 'Pada {date}, {from} menulis:',
  'mailbox.reply.send': 'Kirim',
  'mailbox.reply.sending': 'Mengirim…',
  'mailbox.reply.cancel': 'Batal',
  'mailbox.reply.sent': 'Balasan terkirim',
  'mailbox.reply.failed': 'Email gagal dikirim. Pastikan Email Sending untuk domain ini sudah aktif di Cloudflare. Balasan Anda tetap tersimpan di percakapan.',
  'mailbox.reply.capReached': 'Batas harian {max} balasan sudah tercapai. Coba lagi nanti.',
  'mailbox.reply.thread': 'Balasan',
  'mailbox.reply.noAddress': 'Pesan ini tidak memiliki alamat untuk dibalas.',
  'mailbox.yourAddresses': 'Anda melihat email untuk: {addresses}',
  'mailbox.empty.noAddress': 'Anda belum diberi alamat email. Minta admin menambahkan Anda di Alamat inbox.',
  'mailbox.catchAll': 'Catch-all',
  'mailbox.catchAll.hint': 'Email ke alamat yang tidak ada di daftar alamat. Hanya admin yang bisa melihatnya.',
  'mailbox.addresses.manage': 'Alamat',
  'mailbox.addresses.title': 'Alamat inbox',
  'mailbox.addresses.subtitle': 'Alamat email domain Anda dan siapa saja yang boleh memakainya. Tiap orang hanya melihat, membaca, membalas, dan menghapus email dari alamatnya sendiri.',
  'mailbox.addresses.catchAllNote': 'Admin melihat semua alamat. Email ke alamat yang tidak ada di daftar ini masuk ke catch-all, dan hanya admin yang bisa melihatnya. Kalau alamat dihapus, emailnya tetap ada dan pindah ke catch-all.',
  'mailbox.addresses.adminOnly': 'Hanya admin yang bisa mengatur alamat inbox.',
  'mailbox.addresses.noDomain': 'Situs ini belum punya domain email, jadi belum bisa menambah alamat.',
  'mailbox.addresses.new': 'Tambah alamat',
  'mailbox.addresses.edit': 'Ubah',
  'mailbox.addresses.col.address': 'Alamat',
  'mailbox.addresses.col.people': 'Yang bisa memakai',
  'mailbox.addresses.adminsOnly': 'Hanya admin',
  'mailbox.addresses.empty.title': 'Belum ada alamat',
  'mailbox.addresses.empty.body': 'Tambahkan alamat seperti sales@ supaya tiap orang punya inbox sendiri. Sebelum itu, semua email masuk ke catch-all.',
  'mailbox.addresses.deleteTitle': 'Hapus {address}?',
  'mailbox.addresses.deleteBody': 'Setelah ini hanya admin yang bisa melihat emailnya. Emailnya sendiri tetap disimpan di catch-all.',
  'mailbox.addresses.deleted': 'Alamat dihapus',
  'mailbox.addresses.saved': 'Alamat disimpan',
  'mailbox.addresses.form.local': 'Alamat',
  'mailbox.addresses.form.domain': 'Domain',
  'mailbox.addresses.form.label': 'Label',
  'mailbox.addresses.form.labelHint': 'Opsional, misalnya Tim sales.',
  'mailbox.addresses.form.people': 'Siapa yang bisa memakai alamat ini',
  'mailbox.addresses.form.peopleHint': 'Mereka bisa melihat, membaca, membalas, menandai, dan menghapus emailnya. Balasan dikirim dari alamat ini.',
  'mailbox.addresses.form.noPeople': 'Belum ada orang yang bisa diberi alamat ini. Tambahkan dulu di Pengguna.',
  'mailbox.addresses.form.noInboxAccess': 'Perannya belum termasuk Inbox, jadi alamat ini belum kelihatan sampai perannya diubah.',
  'mailbox.addresses.form.save': 'Simpan',
}
